import React, { Component } from  'react';
import { debounce } from 'vega';
import { drawVis } from "../util";
import { objEqual } from "../../js/util"
import { castVL2VG } from 'gemini/gemini.web';
import {
  Card, Button, Badge
} from 'react-bootstrap'
import AnimContainer from "./../AnimContainer";
import SequenceContainer from "./SequenceContainer";
import "../css/PathView.css"

class PathView extends Component {
  constructor(props){
    super(props);
    this.state = {
      visDrawers: {}
    }

  }


  render() {
    const topN = 10;
    const path = this.props.path;
    const pathId = this.props.pathId;

    return <div className={`path-view border`} >
      <div className="path-info ">
        {this.renderRecomInfo(path)}
      </div>
      <div className="path-body d-flex">
        <div className="sequence-conainter-col">
          <SequenceContainer
            sequence={path.sequence}
            sequenceId={pathId}
            transitions={path.editOpPartition}
          />
        </div>
        <div className="recommendation-conainter-col d-flex">

          {/* show top 10 only */}
          {path.recommendations.filter((recom, i) => i < topN).map((recom, i) => {
            let sSpec = this.props.sSpec;
            try {
              sSpec = castVL2VG(sSpec);

            } catch (e) {
              console.log("WARNING: the given VL spec is invalid to be compiled.")
              sSpec = {}
            }

            return <div className={"recommendation-conainter"} key={`recomView-${pathId}-${i}`}>
            <Card className="h-100">
              <AnimContainer
                  sSpec={sSpec}
                  sequence={path.sequence}
                  animationSpecs={recom.specs.map(spec => spec.spec)}
                  showMetaInfo={false}
                  height={"288px"}
                  showGif={false}
                  id={`recomView-${pathId}-${i}`}

                />
              <Card.Body className="pt-0"></Card.Body>
              <Card.Footer  >
                <div className={"float-left"} style={{lineHeight: "2rem"}}>
                  Complexity: {Math.round(recom.cost * 100)/100}
                </div>
                <Button
                  variant="primary" size="sm" className="float-right"
                  onClick={(event) => { this.onUseRecomBtnClick(path, recom) }}
                >
                  Customize
                </Button>
              </Card.Footer>
            </Card>
          </div>


          })}
        </div>
      </div>

    </div>
  }

  shouldComponentUpdate(nextProps) {
    if (!objEqual(this.props.sSpec, nextProps.sSpec) || !objEqual(this.props.path, nextProps.path)) {
      return true;
    }
    return false;
  }



  async onUseRecomBtnClick(path, recom) {

    await this.props.onChangeSequence(
      path.sequence,
      recom.specs.map(s => s.spec)
    );
    this.props.onHide();
  }


  genDebounceDrawVis(target) {
    return (spec) => {
      debounce(700, async () => { await drawVis( target, spec ) })();
    }
  }

  renderRecomInfo(path) {

    return <ul className="list-inline mb-0 pl-3">
      <li className="list-inline-item">
        <b>Score:</b> {path.eval.score}
      </li>
      {
        path.eval.satisfiedRules.length > 0 ?
        <li className="list-inline-item">
          <b>Applied Rules:</b> {
            path.eval.satisfiedRules.map((rule, i) => {
              return <Badge variant={"secondary"} key={`satRuleBadge-${i}`}>{rule.name}</Badge>
            })
          }
        </li> : ""
      }

    </ul>
  }

}

export default PathView;
